import { TicketFeedbackInterface } from "../../models/TicketModule/TicketFeedback";
import client from "../client";

class FeedbackService {
  async Get(ticketId: string) {
    try {
      let url = `/api/Feedback/${ticketId}`;
      const { data } = await client.get<TicketFeedbackInterface[]>(url);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async Add(feedback: TicketFeedbackInterface) {
    try {
      let url = `/api/Feedback/AddFeedback`;

      const formData = new FormData();

      for (const key in feedback) {
        console.log("key: ", key);
        if (key !== "formImages") {
          formData.append(key, (feedback as any)[key]);
        }
      }
      if (feedback.formImages && Array.isArray(feedback.formImages)) {
        for (let i = 0; i < feedback.formImages.length; i++) {
          const base64Image = feedback.formImages[i];
          const blob = await fetch(base64Image).then((res) => res.blob());
          formData.append("formImages", blob, `image${i}.png`);
        }
      }

      const { data } = await client.post<TicketFeedbackInterface>(
        url,
        formData
      );
      return data;
    } catch (error) {
      throw error;
    }
  }
  async Remove(feedbackId: string) {
    try {
      let url = `api/TicketFeedback/Delete/${feedbackId}`;
      await client.post<TicketFeedbackInterface>(url);
    } catch (error) {
      throw error;
    }
  }
}

export default new FeedbackService();
